import React from 'react';
import classnames from 'classnames';
import formatMoney from 'utils/formatters/Money';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class PaymentSummaryV2 extends React.Component {
    render() {
        const { total, paid, balance, credit_memos, currency, t } = this.props;
        const creditTotal = (credit_memos === null || credit_memos === void 0 ? void 0 : credit_memos.reduce((sum, memo) => sum + ((memo === null || memo === void 0 ? void 0 : memo.total) || 0), 0)) || 0;
        return (React.createElement("div", { "data-testid": "div-ce8ff110", className: "space-y-3" },
            React.createElement("div", { "data-testid": "div-e801a16c", className: "flex items-center justify-between" },
                React.createElement("span", { className: "text-sm text-muted-foreground" }, titleize(t('TOTAL'))),
                React.createElement("span", { className: "font-semibold" }, formatMoney(total, currency))),
            React.createElement("div", { "data-testid": "div-b3c85646", className: "flex items-center justify-between" },
                React.createElement("span", { className: "text-sm text-muted-foreground" }, titleize(t('PAID'))),
                React.createElement("span", { className: "font-semibold" }, formatMoney(paid, currency))),
            React.createElement("div", { "data-testid": "div-416be5b6", className: "flex items-center justify-between" },
                React.createElement("span", { className: "text-sm text-muted-foreground" }, titleize(t('CREDIT'))),
                React.createElement("span", { className: classnames('font-semibold', {
                        'text-red-500': creditTotal > 0,
                    }) }, formatMoney(creditTotal, currency))),
            React.createElement("div", { "data-testid": "div-d377008b", className: "flex items-center justify-between" },
                React.createElement("span", { className: "text-sm text-muted-foreground" }, titleize(t('BALANCE'))),
                React.createElement("span", { className: "font-semibold" }, formatMoney(balance, currency)))));
    }
}
export default withTranslation()(PaymentSummaryV2);
